import React, { useState, useRef, useEffect } from "react";
import "../styles/ChatBot.css";
import Send from "../assets/send.png";
import StartInput from "../assets/input.png";
import ReceiveProfile from "../assets/boticon.png";
import Regenerate from "../assets/regenerate.png";
import axios from "axios";

const ChatBot = () => {
  const chatContainerRef = useRef(null);
  const OPENAI_API_URL = "https://api.openai.com/v1/chat/completions";

  const [messages, setMessages] = useState([
    {
      type: "received",
      text: "How can I help you today?",
      isGenerating: false,
    },
  ]);
  const [inputText, setInputText] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);
  const [lastUserMessage, setLastUserMessage] = useState("");

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    if (chatContainerRef.current) {
      setTimeout(() => {
        chatContainerRef.current.scrollTop =
          chatContainerRef.current.scrollHeight;
      }, 0);
    }
  }, []);

  const handleSendMessage = async () => {
    if (inputText.trim() === "") return;

    setMessages((prevMessages) => [
      ...prevMessages,
      { text: inputText, type: "sent" },
    ]);

    setLastUserMessage(inputText);
    setInputText("");

    await generateResponse(inputText);
  };

  const generateResponse = async (message) => {
    setIsGenerating(true);

    setMessages((prevMessages) => [
      ...prevMessages,
      { text: "", type: "received", isGenerating: true },
    ]);

    try {
      const response = await axios.post(
        OPENAI_API_URL,
        {
          model: "gpt-4",
          messages: [{ role: "user", content: message }],
        },
        {
          headers: {
            Authorization: `Bearer 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`,
            "Content-Type": "application/json",
          },
        }
      );
      const content = response.data.choices[0].message["content"];

      setMessages((prevMessages) => {
        const newMessages = [...prevMessages];
        newMessages[newMessages.length - 1] = {
          text: content,
          type: "received",
          isGenerating: false,
        };
        return newMessages;
      });
    } catch (error) {
      console.error("Error fetching data from OpenAI API:", error);
      setMessages((prevMessages) => {
        const newMessages = [...prevMessages];
        newMessages.pop();
        return [
          ...newMessages,
          {
            text: "Failed to generate response. Please try again.",
            type: "received",
            isGenerating: false,
          },
        ];
      });
    } finally {
      setIsGenerating(false);
    }
  };

  const handleRegenerate = async () => {
    if (lastUserMessage) {
      setMessages((prevMessages) => {
        const newMessages = [...prevMessages];
        if (newMessages.length > 1) newMessages.pop();
        return newMessages;
      });
      await generateResponse(lastUserMessage);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  return (
    <div className="content-wrapper">
      <div className="chat-content">
        <div className="chat-messages" ref={chatContainerRef}>
          <div className="message-icon"></div>
          {messages.map((message, index) => (
            <div key={index} className={`message-box ${message.type}`}>
              {message.type === "received" && (
                <div className="message-icon">
                  <img src={ReceiveProfile} alt="icon" />
                </div>
              )}
              <div className="message-text ">
                <p>
                  {message.text}
                  {message.isGenerating && (
                    <span className="dots-animation">Generating</span>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="chat-input">
          <img src={StartInput} alt="start" className="input-icon start-icon" />
          <input
            type="text"
            placeholder="Send a message..."
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isGenerating}
          />
          <img
            src={Send}
            alt="send"
            className="send-icon"
            onClick={handleSendMessage}
            style={{ cursor: isGenerating ? "not-allowed" : "pointer" }}
          />
          <img
            src={Regenerate}
            alt="regenerate"
            className="gene-icon"
            onClick={handleRegenerate}
            style={{ cursor: isGenerating ? "not-allowed" : "pointer" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatBot;
